import { AxiosInstance } from 'axios'

import { UserSearchResult } from '@dc-shared-web/hooks/api/user'

export type GetSearchResultQueryParams = {
  page: number
  limit: number
  sortField: string
  search?: string
  active?: boolean
  teamId?: string
  teamUUID?: string
}

export const fetchSearchUserResult = async (
  apiClient: AxiosInstance,
  params?: GetSearchResultQueryParams
): Promise<UserSearchResult> => {
  const { data } = await apiClient.get(`/api/users`, {
    params,
  })
  return data
}
